// extracted by mini-css-extract-plugin
module.exports = {"section":"N_section__MAE2L","space1":"N_space1__dppuC","space2":"N_space2__WP_0s"};